import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { listAddOns, retrieveGetParams } from "../../../../../../utils";
import { addAddOn } from "../../../../../../utils";
import { useHistory, useLocation } from "react-router-dom";
import { Button, Container, Grid } from "@material-ui/core";
import ListTable from "./../../../../../TableComponents/ListTable";
import StatusTag from "../../../../../TagComponents/StatusTag";
import Form from "../../../../../Form/Form";
import notEmpty from "../../../../../../FormValidation/notEmpty";
import noWhiteSpace from "../../../../../../FormValidation/noWhiteSpace";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ListCard from "../../../../../MobileCards/ListCard";
import EmptyListImage from "../../../../../EmptyListImage/Empty";
import CModal from "../../../../../Form/CModal";
import { CircularProgress } from "@material-ui/core";
import LightTooltip from "../../../../../Form/LightTooltip";
import CurrencyPreProcessor from "../../../../../CurrencyFormatter/CurrencyFormatter";
import positive from "../../../../../../FormValidation/positive";
import PostFilter, { applyFilters } from '../../../../../Filter/PostFilter'

const useStyles = makeStyles((theme) => ({
  mainWrapper: {
    width: "100%",
    paddingLeft: "50px",
    paddingRight: "50px",
    paddingTop: "15px",
  },
  rightElem: {
    float: "right",
  },
  topHeadingOne: {
    fontSize: "20px",
    color: "#1a1f36",
  },
  mobilePadding: {
    width: "100%",
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  buttonBasic: {
    fontSize: "14px",
    marginLeft: '10px',
    textTransform: "none",
  },
  headingWrapper: {
    paddingBottom: "15px",
    boxShadow: "inset 0 -1px #e3e8ee",
  },
  headerPadding: {
    paddingBottom: "10px",
  },
  mobileTopHeadingOne: {
    fontSize: "22px",
    fontWeight: "bold",
    color: "#1a1f36",
  },
  topHeading: {
    fontSize: "28px",
    fontWeight: "bold",
    color: "#1a1f36",
  },
  contentRow: {
    paddingTop: "15px",
    paddingBottom: "25px",
  },
  bottomSpacer: {
    height: "50px",
  },
  largeWidth: {
    maxWidth: "calc(100vh - 370px)"
  },
  stickyHeader: {
    position: "sticky",
    top: 64,
    paddingLeft: "10px",
    paddingRight: "10px",
    paddingTop: "10px",
    paddingBottom: "10px",
    backgroundColor: "#ffffff",
    boxShadow: "inset 0 -1px #e3e8ee"
  },
  loaderMain: {
    position: "absolute",
    top: "50%",
    left: "50%"
  },
  formContainer: {
    border: '20px',
    backgroundColor: 'white',
    borderRadius: '10px',
    padding: "20px",
    maxWidth: "600px"
  }
}));

const keyObjects = [
  {
    key: 'isActive',
    label: 'Status',
    keyLabel: 'statusName'
  },
  {
    key: 'type',
    label: 'Type',
    keyLabel: 'type'
  },
  {
    key: 'sellBy',
    label: 'Sell Basis',
    keyLabel: 'sellBy'
  },

]

const AddOnList = () => {
  const classes = useStyles();
  const [add, setAdd] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const queryParams = retrieveGetParams(location)
  const large = useMediaQuery('(min-width: 960px)');
  const small = useMediaQuery('(min-width: 750px)');
  const [type, setType] = useState("O");
  const businessId = useSelector((state) => {
    return state.buisnessDetails.businessId;
  });
  const currencyInfo = useSelector((state) => {
    return state.buisnessDetails.operatingUnitInfo;
  });

  const addOnHeaders = [
    {
      name: "status",
      columnKey: "status",
      columnWidth: "100px",
    },
    {
      name: "name",
      columnKey: "name",
      columnWidth: "80%",
      tooltip: true
    },
    {
      name: "type",
      columnKey: "type",
      columnWidth: "80%",
      tooltip: true
    },
    {
      name: "price",
      columnKey: "transPrice",
      columnWidth: "75px"
    },
    {
      name: "sell basis",
      columnKey: "sellBy",
      columnWidth: "100px"
    }
  ];

  const [initialState, setInitialState] = useState(null);
  const [addOnList, setAddOnList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentLimit, setCurrentLimit] = useState(20);

  async function handleSubmit(event) {
    dispatch({
      type: 'UPDATE', payload: {
        loading: true
      }
    });
    let success = await addAddOn({
      businessId: businessId,
      name: event.name,
      displayName: event.displayName,
      type: event.type,
      sellBy: event.sellBy,
      description: event.description ? event.description : null,
      price: event.price,
      duration: event.type != "Service" ? null : event.duration
    })
    dispatch({
      type: 'UPDATE', payload: {
        loading: false
      }
    });
    if (success) {
      history.push(`${location.pathname}/${success.addOnId}`);
    }
  };

  const processAddOnsData = (addOnData) => {
    return addOnData.map((addOn) => {
      let {
        addOnId,
        name,
        isActive,
        sellBy,
        type,
        price
      } = addOn;

      let status = <StatusTag wrapperName={isActive ? "greenWrapper" : "redWrapper"} value={isActive ? "Active" : "Inactive"} />;
      let id = addOnId;
      let transPrice = <CurrencyPreProcessor amount={price}
        currencyBreak={currencyInfo.currencyBreak}
        roundingFactor={currencyInfo.roundingFactor}
        currencySymbol={currencyInfo.currencySymbol}
      />;

      return {
        id,
        isActive,
        name,
        status,
        sellBy,
        type,
        transPrice,
        statusName: isActive ? "Active" : "Not Active"
      };
    });
  };

  const getAddOnsDetails = async () => {
    let addOnsPayload = await listAddOns({
      businessId: businessId
    });
    if (addOnsPayload && addOnsPayload.addOnDetails) {
      setAddOnList(processAddOnsData(addOnsPayload.addOnDetails));
      setInitialState(true);
    }
  };

  const navigateToAddOn = (addOnId) => {
    history.push(`/dashboard/${businessId}/Add-Ons/${addOnId}`);
  };

  const ViewChanger = () => {
    if (small) {
      return (
        <ListTable
          identifier={"admin_orders"}
          tableHeaders={addOnHeaders}
          tableRows={applyFilters(addOnList, queryParams, keyObjects)}
          rowClick={navigateToAddOn}
        />
      );
    } else {
      return (
        applyFilters(addOnList, queryParams, keyObjects).map((mobileAddOn) => {
          return (
            <ListCard
              action={() => { history.push(`/dashboard/${businessId}/Add-Ons/${mobileAddOn.id}`); }}
              cardName={mobileAddOn.name}
              statusTagValue={mobileAddOn.isActive}
              activeValue="Active"
              inactiveValue="Inactive"
              other={mobileAddOn.transPrice}
            />
          )
        })
      );
    };
  };


  useEffect(async () => {
    dispatch({
      type: "UPDATE",
      payload: {
        loading: true,
      },
    });
    await getAddOnsDetails();
    dispatch({
      type: "UPDATE",
      payload: {
        loading: false,
      },
    });
  }, [currentPage, currentLimit]);

  if (initialState === null) {
    return (
      <Grid container className={classes.mainWrapper}>
        <Grid item xs={12}>
          <div className={classes.loaderWrapper}>
            <CircularProgress className={classes.loaderMain} />
          </div>
        </Grid>
      </Grid>
    );
  } else {
    return (
      <Grid container className={large ? classes.mainWrapper : !large && small ? classes.mobilePadding : null}>
        <CModal open={add} setOpen={setAdd}
          children={
            <Container component="main" className={classes.formContainer}>
              <Form
                action={handleSubmit}
                postAction={null}
                cancelEnabled
                title="Create Add-On"
                cancelAction={() => { setAdd(false); }}
                cancelText="Cancel"
                submitText="Create"
                inputFields={
                  [
                    {
                      type: "TextField",
                      validator: [notEmpty, noWhiteSpace],
                      label: "Name",
                      name: "name",
                    },
                    {
                      type: "TextField",
                      validator: [notEmpty, noWhiteSpace],
                      initialvalue: "",
                      label: "Display Name",
                      name: "displayName",
                    },
                    {
                      type: "SingleSelect",
                      validator: [notEmpty, value => (value == "Service" ? setType("S") : setType("O")), value => value == null ? "Must chose at least one product type" : null],
                      label: "Type",
                      name: "type",
                      choices: [
                        ["Service", "Service"],
                        ["Physical Product", "Physical Product"],
                        ["Digital Product", "Digital Product"],
                        ["Rental", "Rental"],
                        ["Financial", "Financial"]
                      ]
                    },
                    {
                      type: "SingleSelect",
                      validator: [notEmpty, value => value == null ? "Must chose at least one selling basis" : null],
                      label: "Sell Basis",
                      name: "sellBy",
                      choices: [
                        ["Per Session", "Per Session"],
                        ["Per Attendee", "Per Attendee"]
                      ]
                    },
                    {
                      type: "Currency",
                      validator: [notEmpty, positive],
                      currencyInfo: currencyInfo,
                      label: "Price",
                      name: "price",
                    },
                    {
                      type: "Number",
                      validator: [notEmpty, positive],
                      label: "Duration (min)",
                      name: "duration",
                      enabled: type == "S"
                    },
                    {
                      type: "TextArea",
                      name: "description",
                      label: "Description (optional)",
                      size: {
                        xs: 12
                      },
                      resizeEnabled: false,
                      moreProps: {
                        rowsMin: 4,
                        rowsMax: 10
                      }
                    }
                  ]
                }
              >
              </Form>
            </Container>
          }
        />
        <Grid container direction="row" item xs={12} className={small ? null : classes.stickyHeader} style={!large && small ? { paddingTop: "15px" } : null}>
          <Grid item xs={6}>
            <div className={classes.headerPadding}>
              <span className={small ? classes.topHeading : classes.mobileTopHeadingOne}>Add Ons</span>
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className={classes.headerPadding}>
              <LightTooltip title="Create Add On" arrow>
                <span className={classes.rightElem}>
                  <Button className={classes.buttonBasic} variant='contained' color='primary' onClick={() => { setAdd(true); }}>Add</Button>
                </span>
              </LightTooltip>
              <PostFilter allEntries={addOnList} keyObjects={keyObjects} />
            </div>
          </Grid>
        </Grid>
        {addOnList.length > 0 ?
          <Grid item xs={12} className={small ? null : classes.mobilePadding}>
            <div>
              <ViewChanger />
            </div>
          </Grid> : <EmptyListImage name="Add Ons" />}
        <Grid item xs={12}>
          <div className={classes.bottomSpacer}></div>
        </Grid>
      </Grid>
    );
  }
};

export default AddOnList;